<template>
  <div class="sidebar-wrapper">
    <div
      id="sidebar-container"
      :class="{
        'sidebar-expanded sidebar-container-border': !isCollapsed,
        'sidebar-collapsed': isCollapsed && innerWidth <= optimizedWindowWidth,
      }"
    >
      <!-- Collapse button -->
      <div
        v-if="innerWidth <= optimizedWindowWidth"
        class="collapse-block"
        :style="`${isCollapsed && innerWidth <= optimizedWindowWidth ? 'right: -40px;width: 40px;height: 40px;' : ''}`"
      >
        <a href="#" class="collapse-btn" :style="`${isCollapsed && innerWidth <= optimizedWindowWidth ? 'padding: 0;' : ''}`" @click="toggleCollapse">
          <span v-if="isCollapsed && innerWidth <= optimizedWindowWidth">
            <img :src="burgerIcon" style="width: 30px; margin-top: 5px" />
          </span>
          <span v-else>
            <img :src="doubleArrowLeft" />
          </span>
        </a>
      </div>
      <!--/ Collapse button END -->
      <div class="sidebar-header">
        <div class="sidebar-header-container">
          <div v-if="license" class="app-info">
            <div v-if="isIIProject || isAVGProject || isGMVAProject">
              <span>
                <div v-if="!logoUrl" class="ii-logo-text" />
                <img v-else :src="logoUrl" class="ii-logo-text" />
              </span>
            </div>
            <div v-else>
              <span>{{ appName }}</span>
            </div>
          </div>
          <div v-else class="ii-logo-text" />
          <div v-if="license" class="license-info">
            <div class="license-info-container">
              <span>{{ 'licensed_for' | i18n }} {{ license.ownerCompanyName }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Bootstrap List Group -->
      <ul class="main-menu list-group">
        <!-- Menu Block -->
        <div v-for="(block, index) in menu" :key="block.name + index">
          <div v-if="block.name" class="d-flex align-items-center block-wrapper">
            <div v-if="block.icon">
              <span v-if="block.name === 'Reports' && isDIGITAL35Project">
                <img class="block-icon" style="opacity: 0">
              </span>
              <img
                v-else-if="block.name === 'Reports' || block.name === 'One' || block.name === 'View'"
                :src="block.icon"
                class="block-icon"
              >
            </div>
            <div v-if="block.name" class="block-name" :class="{ 'block-name-active': block.activeItemPosition + 1 }">
              {{ block.name | i18n }}
            </div>
          </div>
          <!-- Menu Item -->
          <div v-for="(item, i) in block.items" :key="item.name" class="list-group-wrapper">
            <div
              v-if="block.name"
              class="navigation-line"
              :class="{ 'navigation-line-left-active': block.activeItemPosition > i, 'navigation-line-active': item.isActive }"
            />
            <router-link
              :to="item.route"
              class="list-group-item list-group-item-action flex-column noselect align-items-start"
              :class="{ active: item.isActive, 'list-group-item-padding': block.name, 'group-item-without-hover': !block.name }"
            >
              <div class="d-flex w-100 align-items-center justify-content-start">
                <span :class="`section-icon ${!block.name ? 'section-icon-small-m' : ''}`">
                  <img :src="item.isActive ? item.activeIcon : item.icon" />
                </span>
                <span class="menu-item-title" :id="item.titleKey">{{ item.titleKey | i18n }}</span>
                <span class="submenu-icon ml-auto">
                  <img v-if="item.submenus && item.submenus.length" :src="item.isCollapsed ? collapseOpenIcon : collapseClosedIcon" />
                </span>
              </div>
            </router-link>
            <!-- Submenu Item -->
            <b-collapse v-if="item.submenus && item.submenus.length" :id="item.name" v-model="item.isCollapsed" class="submenu">
              <router-link
                v-for="subitem in item.submenus"
                :key="subitem.name"
                :to="subitem.route"
                tag="a"
                class="list-group-item list-group-item-action menu-item-title"
                :class="{ active: item.isActive }"
              >
                {{ subitem.titleKey | i18n }}
              </router-link>
            </b-collapse>
            <!--/ Submenu Item END-->
            <!--/ SubmenuV2 Item-->
            <div v-if="item.submenuV2 && item.submenuV2.length" class="submenu">
              <router-link
                v-for="subitem in item.submenuV2"
                :key="subitem.name"
                :to="subitem.route"
                tag="a"
                class="list-group-item list-group-item-action menu-item-title"
                :class="{ active: item.isActive }"
                style="padding-left: 100px"
              >
                {{ subitem.titleKey | i18n }}
              </router-link>
            </div>
            <!--/ SubmenuV2 Item END-->
          </div>
        </div>
      </ul>
      <!-- List Group END-->
      <div class="logout-wrapper">
        <b-button variant="link" class="logout-btn" @click="onSignOut">
          <img :src="logoutIcon" alt="logout icon" />
          <span class="logout-text">
            {{ 'sign_out' | i18n }}
          </span>
        </b-button>
        <small class="version">{{ appVersion }}</small>
      </div>
    </div>
    <!-- sidebar-container END -->
  </div>
</template>

<script>
import collapseClosedIcon from '../../assets/icons/collapse-closed.svg';
import burgerIcon from '../../assets/icons/burger.svg';
import collapseOpenIcon from '../../assets/icons/collapse-open.svg';
import doubleArrowLeft from '../../assets/icons/double_arrow_left.svg';
import licenseIcon from '../../assets/icons/license.svg';
import lock from '../../assets/icons/lock.svg';
import questionMarkIcon from '../../assets/icons/question_mark.svg';
import guideIcon from '../../assets/icons/grey/guide.svg';
import logoutIcon from '../../assets/icons/logout.svg';
import { BCollapse } from 'bootstrap-vue';
import axios from 'axios';

import { LicenseMixin, NotificationMixin, UpdateMixin, AuthMixin } from '../../mixins';
import IIlogoText from '../../assets/logo-ii-text.png';
import digital35Logo from '../../assets/digital35.png';
import sensisLogo from '../../assets/sensis-logo.svg';
import gmvaLogo from '../../assets/gmva_logo.png';

import { mapActions, mapState } from 'vuex';

export default {
  name: 'Sidebar',
  components: { 'b-collapse': BCollapse },
  mixins: [LicenseMixin, NotificationMixin, UpdateMixin, AuthMixin],
  props: {
    appName: {
      type: String,
      default: '',
    },
    appShortName: {
      type: String,
      default: '',
    },
    appVersion: {
      type: String,
      default: '',
    },
    isCollapsedByDefault: {
      type: Boolean,
      default: false,
    },
    menu: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      expireAlert: false,
      burgerIcon: burgerIcon,
      collapseClosedIcon: collapseClosedIcon,
      collapseOpenIcon: collapseOpenIcon,
      doubleArrowLeft: doubleArrowLeft,
      licenseIcon: licenseIcon,
      lock: lock,
      guideIcon: guideIcon,
      logoutIcon: logoutIcon,
      questionMarkIcon: questionMarkIcon,
      optimizedWindowWidth: 1100,
      innerWidth: 1200,
      baseURL: axios.defaults.baseURL,
      logoUrl: '',
    };
  },
  computed: {
    ...mapState({
      isCollapsed: (state) => state.frame.isCollapsed,
    }),
  },
  watch: {
    menu() {
      this.setActiveMenuItem(this.$route.path);
    },
    $route(to) {
      this.setActiveMenuItem(to.path);
      if (window.innerWidth <= this.optimizedWindowWidth) {
        this.setIsCollapsed(true);
      }
    },
    async license(l) {
      if (l.leftDays < -1) {
        await this.updateServer();
      }
      if (l.leftDays < 30 && !this.expireAlert) {
        this.showNotification({
          type: 'error',
          title: this.$translate('Licence'),
          message: this.$translate('The license for this instance is due for renewal'),
        });
        this.expireAlert = true;
      }
      if (l) {
        await this.renderIIlogoText();
      }
    },
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeFunction);
  },
  async created() {
    if (this.license) {
      await this.renderIIlogoText();
    }
    this.setIsCollapsed(this.isCollapsedByDefault);

    this.setActiveMenuItem(this.$route.path);

    window.addEventListener('resize', this.resizeFunction);
    this.resizeFunction();
  },
  methods: {
    ...mapActions({ setIsCollapsed: 'frame/setIsCollapsed' }),
    setActiveMenuItem(routePath) {
      this.menu.forEach((block) => {
        block.items.forEach((menuItem) => {
          menuItem.isActive =
            menuItem.route === routePath ||
            (menuItem.submenus && menuItem.submenus.find((submenuItem) => submenuItem.route === routePath)) ||
            (menuItem.submenuV2 && menuItem.submenuV2.find((submenuItem) => submenuItem.route === routePath));
        });
        block.activeItemPosition = block.items.findIndex(({ isActive }) => isActive);
      });
    },
    resizeFunction() {
      this.innerWidth = window.innerWidth;
      if (window.innerWidth <= this.optimizedWindowWidth) {
        this.setIsCollapsed(true);
      }
    },
    logoError() {
      if (this.isAVGProject || this.isEKAVProject) {
        return (this.logoUrl = sensisLogo);
      }
      if (this.isDIGITAL35Project) {
        return (this.logoUrl = digital35Logo);
      }
      if (this.isGMVAProject) {
        return (this.logoUrl = gmvaLogo);
      }
      this.logoUrl = IIlogoText;
    },
    async renderIIlogoText() {
      try {
        const url = `${this.baseURL}/api/v1/static/pdf-templates/companyLogo.png?dummy=${Math.random()}`;
        const data = await axios(url);
        if (!data) {
          return this.logoError();
        } else {
          if (data.includes('DOCTYPE')) {
            return this.logoError();
          }
          this.logoUrl = url;
        }
      } catch (error) {
        this.logoError();
      }
    },
    toggleCollapse() {
      this.setIsCollapsed(!this.isCollapsed);
    },
    onSignOut() {
      this.$emit('sign-out');
    },
  },
};
</script>

<style scoped lang="scss">
.sidebar-wrapper {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1000;
  height: 100vh;
}

#sidebar-container {
  padding: 0;
  position: relative;
  height: 100%;

  transition: width 0.3s;

  /* Menu item*/
  .sidebar-submenu {
    transition: all 0.3s;
  }

  .menu-item-title {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 19px;
  }

  .main-menu::-webkit-scrollbar {
    width: 0px; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }

  @media screen and (max-width: 870px) {
    .main-menu {
      padding-bottom: 100px !important;
    }
  }

  .main-menu {
    overflow: hidden;
    overflow-y: auto;
    padding-top: 5px;
    &.list-group {
      border-radius: 0;
    }
    .list-group-wrapper {
      position: relative;
      .navigation-line {
        width: 8px;
        height: 34px;
        position: absolute;
        left: 21px;
        bottom: 16px;
        border-bottom: 1px solid;
        border-left: 1px solid;
        border-color: rgba(34, 96, 255, 0.2);
        &.navigation-line-active {
          border-color: #2260ff;
        }
        &.navigation-line-left-active {
          border-left-color: #2260ff;
        }
      }
      & .group-item-without-hover:hover,
      & .group-item-without-hover.active {
        background: inherit;
      }
      &:nth-child(2) > .navigation-line {
        height: 20px;
      }
      &:nth-child(1) {
        & > .list-group-item:hover,
        & > .list-group-item.active {
          background: inherit;
        }
        & > .navigation-line {
          display: none;
        }
      }
      &:nth-child(1) .section-icon,
      & .section-icon-small-m {
        margin-right: 6px;
      }
    }
    .block-wrapper {
      padding: 6px 20px;
      .block-icon {
        width: 16px;
        height: 16px;
        margin-right: 6px;
        margin-bottom: 3px;
        border-radius: 3px;
      }
      .block-name {
        color: #646a87;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        &.block-name-active {
          color: #2260ff;
        }
      }
      .text-items-center {
        text-align: center;
      }
    }
    .list-group-item {
      padding: 10px 20px;
      border: none;
      line-height: 1rem;
      cursor: pointer;
      white-space: normal;
      border-radius: 8px 0px 0px 8px;
      background-color: inherit;

      .menu-item-title {
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #0f2041;
      }

      .secondary-menu-item-title {
        font-size: 0.815rem;
        line-height: 1rem;
      }

      &:hover,
      &.active {
        background: rgba(34, 96, 255, 0.1);
      }
      &.active {
        .section-icon {
          color: #2260ff;
        }

        .menu-item-title {
          font-weight: 500;
          color: #2260ff;

          a {
            text-decoration: none !important;
          }
        }
      }
    }
    .list-group-item-padding {
      padding: 6px 7px;
      margin-left: 30px;
      margin-bottom: 1px;
    }
    .submenu .list-group-item:first-child {
      padding-top: 8px;
    }
  }

  .submenu {
    .list-group-item {
      padding: 8px 20px 8px 55px;
      width: auto;

      &.menu-item-title {
        font-size: 0.76rem;
        color: #7586a5;
        text-decoration: none;
        line-height: 1rem;
      }
    }

    .router-link-active {
      font-weight: 600;
    }
  }

  .bottom-links {
    margin-top: auto;

    .section-icon {
      color: #495057;
      margin-bottom: 0 !important;

      img {
        height: 16px;
        width: 16px;
      }
      svg {
        height: 16px;
        width: 16px;
      }
    }

    .list-group-item {
      padding: 6px 16px;
      font-size: 0.76rem;

      &:last-child {
        padding-bottom: 16px;
      }
    }
  }

  .collapse-block {
    position: absolute;
    width: 27px;
    height: 30px;
    line-height: 30px;
    background: #ffffff;
    right: -27px;
    cursor: pointer;
    text-align: center;

    .collapse-btn {
      height: auto;
      padding: 7px 12px;
      position: relative;
      z-index: 1;
    }
  }

  &.sidebar-collapsed .collapse-btn img {
    transform: rotate(180deg);
    transition: transform 0.3s;
  }

  .sidebar-header {
    padding: 15px 20px;

    .sidebar-header-container {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .app-info,
    .license-info {
      display: block;

      span {
        color: #2260ff;
      }
    }

    .app-info span {
      flex-grow: 1;
      font-weight: 500;
      font-size: 22px;
      line-height: 26px;
    }

    .license-info {
      margin-top: 10px;

      .license-info-container {
        display: inline-block;
        background: rgba(34, 96, 255, 0.1);
        border-radius: 3px;
        padding: 0 4px;
        line-height: 14px;

        span {
          font-size: 9px;
          line-height: 14px;
          font-weight: normal;
        }
      }
    }

    .version {
      line-height: 26px;
      position: absolute;
      top: 3px;
      right: 15px;
      font-size: 10px;
      color: #80868b;
    }
  }

  &.sidebar-expanded {
    display: flex;
    flex-direction: column;
    width: 292px;
    background-color: #f7f7f9;
    .section-icon {
      margin-right: 10px;
      margin-bottom: 1px;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      width: 16px;
      height: 16px;
      text-align: center;
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  &.sidebar-collapsed {
    width: 70px;

    .sidebar-header-container {
      padding-bottom: 35px;
    }
  }
  .logout-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 20px 30px;
    .logout-btn {
      overflow: hidden;
      display: flex;
      align-items: center;
      padding: 0;
      .logout-text {
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #0f2041;
        padding-left: 5px;
      }
      &.btn-link:hover {
        color: #0f2041;
      }
    }
    .version {
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      letter-spacing: 0.06em;
      color: #646a87;
      overflow: hidden;
    }
  }
}

@media (max-width: 1100px) {
  .sidebar-wrapper {
    position: fixed;
  }

  #sidebar-container {
    &.sidebar-expanded {
      width: 250px;
    }

    &.sidebar-collapsed {
      width: 0;

      .main-menu {
        display: none;
      }
    }
  }
}

.ii-logo-text {
  height: 36px;
}

.ii-logo {
  height: 34px;
  width: 34px;
}

.small-version {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}

.small-version small {
  font-size: 12px !important;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}
</style>
